import { createTheme, responsiveFontSizes, Theme } from '@mui/material';

declare module '@mui/material/styles' {
  interface Palette {
    neutral: Palette['primary'];
    gradients: {
      primary: string;
      secondary: string;
      page: string;
    };
  }
  interface PaletteOptions {
    neutral: PaletteOptions['primary'];
    gradients?: {
      primary: string;
      secondary: string;
      page: string;
    };
  }
}

const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#6772e5',
      light: '#7795f8',
      dark: '#5469d4',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#4284db',
      light: '#5a9eea',
      dark: '#3b7dd8',
      contrastText: '#ffffff',
    },
    neutral: {
      main: '#64748B',
      light: '#94A3B8',
      dark: '#475569',
    },
    gradients: {
      primary: 'linear-gradient(135deg, #6772e5 0%, #4284db 100%)',
      secondary: 'linear-gradient(135deg, #4284db 0%, #3b7dd8 100%)',
      page: 'linear-gradient(180deg, rgba(246,249,254,1) 0%, rgba(238,244,254,1) 100%)',
    },
    text: {
      primary: '#1A1A1A',
      secondary: '#666666',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h3: {
      fontSize: '40px',
      fontWeight: 700,
      lineHeight: 1.2,
    },
    h6: {
      fontSize: '16px',
      fontWeight: 500,
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
    MuiRating: {
      styleOverrides: {
        root: {
          color: '#FFB800',
        },
      },
    },
  },
});

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#90caf9',
      light: '#e3f2fd',
      dark: '#42a5f5',
    },
    secondary: {
      main: '#ce93d8',
      light: '#f3e5f5',
      dark: '#ab47bc',
    },
    neutral: {
      main: '#94A3B8',
      light: '#CBD5E1',
      dark: '#64748B',
    },
    background: {
      default: '#121212',
      paper: '#1e1e1e',
    },
  },
});

// Apply common theme settings
[lightTheme, darkTheme].forEach((theme) => {
  theme.shape.borderRadius = 8;

  theme.components = {
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        },
      },
    },
  };
});

export const getTheme = (mode: 'light' | 'dark'): Theme => {
  const theme = mode === 'light' ? lightTheme : darkTheme;
  return responsiveFontSizes(theme);
}; 